import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdobeAnalyticsService } from 'src/app/adobe-analytics/services/adobe-analytics.service';
import { StartupService } from 'src/app/common/services/startup.service';
import { BrandService } from 'src/app/common/services/brand-service';
import { CommonUtilities } from '../../shared/util/common-utilities';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';
import { ButtonControlComponent } from 'ui-common-components-angular';
import { TealiumScriptService } from 'src/app/tealium-script/tealium-script.service';

@Component({
    selector: 'olb-app-chat-info',
    templateUrl: './chat-info.component.html',
    styleUrls: ['./chat-info.component.scss'],
    imports: [NgClass, ButtonControlComponent]
})
export class ChatInfoComponent implements OnInit, OnDestroy {
  public isCahoot = false;
  public chatbotElementSubscription: Subscription;

  constructor(
    private startup: StartupService,
    private adobeAnaylticsService: AdobeAnalyticsService,
    private readonly brandService: BrandService,
    private readonly tealiumService: TealiumScriptService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.isCahoot = this.brandService.isCahoot();
  }

  triggerEngagement() {
    this.chatbotElementSubscription = this.adobeAnaylticsService.triggerEngagement(this.startup.chatWithUs);
    this.tealiumService.trackEvent(this.startup.chatWithUs);
  }

  ngOnDestroy(): void {
    if(CommonUtilities.isNotNullEmptyAndUndefined(this.chatbotElementSubscription)){
      this.chatbotElementSubscription?.unsubscribe();
    }
  }
  
}
